import './Privacy.css'

export default function Privacy() {
  return (
    <main>
      <section className="privacy safearea">
        <h1>Privacy Policy</h1>
        <div className="privacy__content">
          <h2>1. Introduction</h2>
          <p>
            This Privacy Policy explains how we handle your information when you
            visit our website. We are committed to protecting
            your privacy and complying with the General Data Protection
            Regulation (GDPR).
          </p>

          <h2>2. Information We Collect</h2>
          <p>
            Our site operates with minimal data collection practices. While we
            do not actively collect personal information like names or emails,
            web servers and our security infrastructure necessarily process your
            IP address temporarily to deliver the website to your device and
            protect against security threats. Our lawful basis for this
            processing under GDPR is our <strong>Legitimate Interest</strong> in
            maintaining a secure and functional website.
          </p>

          <h2>3. Analytics and Web Performance</h2>
          <p>
            We use Cloudflare Analytics to understand how visitors use our
            website and to improve our services. Cloudflare Analytics is a
            privacy-focused analytics service that does not use cookies and
            does not require consent under GDPR. This service provides us with
            anonymized, aggregated data about page views and traffic patterns.
          </p>

          <p>
            Cloudflare's analytics collection is performed at the edge and does
            not involve storing personal data. For more information about
            Cloudflare's privacy practices, please visit their privacy policy at{' '}
            <a
              href="https://www.cloudflare.com/privacypolicy/"
              target="_blank"
              rel="noopener noreferrer"
            >
              cloudflare.com/privacypolicy/
            </a>
            .
          </p>

          <h2>4. Cookies</h2>
          <p>
            We do not use or set any first-party or third-party cookies on this
            website. If you click on a link to an external website, that site
            may set its own cookies according to its own privacy policies.
          </p>

          <h2>5. Third-Party Links</h2>
          <p>
            Our website contains links to external services, including
            Cloudflare and other platforms. We are not responsible for the
            privacy practices of these third-party services. We recommend
            reviewing their privacy policies before interacting with them.
          </p>

          <h2>6. Your Rights Under GDPR</h2>
          <p>Under GDPR, you have the right to:</p>
          <ul>
            <li>Access any personal data we may hold about you</li>
            <li>Request correction of inaccurate personal data</li>
            <li>Request deletion of your personal data</li>
            <li>Request restriction of processing</li>
            <li>Object to processing of your data</li>
            <li>Data portability</li>
            <li>
              <strong>
                Lodge a complaint with a data protection supervisory authority
              </strong>
            </li>
          </ul>
          <p>
            Since we collect minimal personal data (such as temporary IP
            addresses), these rights are largely inapplicable to your standard
            browsing. However, if you have any concerns, please contact us.
          </p>

          <h2>7. Data Security</h2>
          <p>
            We rely on Cloudflare's infrastructure to ensure the security of our
            website. All data transmission is encrypted using HTTPS.
          </p>

          <h2>8. Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy at any time. Changes will be
            posted on this page with an updated effective date. Your continued
            use of the website constitutes acceptance of any changes.
          </p>

          <h2>9. Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy or our privacy
            practices, please contact us via email at{'info@mcontrol.dev'}
            <a href="mailto:info@mcontrol.dev">info@mcontrol.dev</a>{' '}
            or through our Discord server at{' '}
            <a
              href="https://discord.gg/ta6hYeEB4k"
              target="_blank"
              rel="noopener noreferrer"
            >
              discord.gg/ta6hYeEB4k
            </a>
            .
          </p>

          <p className="last-updated">
            <strong>Last Updated:</strong> May 2026
          </p>
        </div>
      </section>
    </main>
  )
}
